import { render, staticRenderFns } from "./moreOXT.vue?vue&type=template&id=06d58046&lang=pug&"
import script from "./moreOXT.vue?vue&type=script&lang=js&"
export * from "./moreOXT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports